import type { Housing } from '~/models/Housing';

/**
 * Construct the url to view housing details from a housing object. Our project routing
 * is built to use these urls to show the respective housing information.
 *
 * @param housing Housing
 * @returns string
 */
export default function (housing: Housing) {
  const housingType = housing.type.display.toLowerCase(); // wohnung|haus|wg-zimmer
  const transactionType = 'mieten'; // hardcoded for now, will change as soon as buying is introduced
  const city = housing.geo.city.toLowerCase();
  const area = housing.geo.area ? housing.geo.area.toLowerCase().replace('/', '-') : '';
  const titleAndId = housing.uriString;

  return `/${encodeURIComponent(housingType)}-${encodeURIComponent(transactionType)}/${encodeURIComponent(city)}${
    area ? `/${encodeURIComponent(area)}` : ''
  }/${encodeURIComponent(titleAndId)}`;
}
